import { Sidebar } from "@datamole/wds-component-sidebar";

import styles from "@/components/shared/app-layout/sidebar/header/header.module.css";
import { Button } from "@/components/ui/button";
import { MenuIcon, MenuCloseIcon } from "@/components/ui/icon";

interface Props {
    sidebarCollapsed: boolean;
    toggleSidebarCollapsed: () => void;
}

export const Header = ({ sidebarCollapsed, toggleSidebarCollapsed }: Props) => {
    const Icon = sidebarCollapsed ? MenuIcon : MenuCloseIcon;

    return (
        <Sidebar.Header className={styles.header}>
            <Button
                variant="secondary"
                onClick={() => {
                    toggleSidebarCollapsed();
                }}
                startIcon={
                    <Icon
                        alt={sidebarCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}
                        className={styles.expand_collapse_icon}
                    />
                }
            />
        </Sidebar.Header>
    );
};
